import { render, staticRenderFns } from "./DialogDetail.vue?vue&type=template&id=0cd828b6&scoped=true"
import script from "./DialogDetail.vue?vue&type=script&lang=js"
export * from "./DialogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd828b6",
  null
  
)

export default component.exports